import { Button, ButtonGroup, useTheme } from '@mui/material';
import { Condition } from '../../../../types/marketing';

interface ConfitionButtonGroupProps {
  condition: Condition;
  onChange: (value: Condition) => void;
}
function SingleConditionButton({
  condition,
  onChange,
  currentCondition,
}: ConfitionButtonGroupProps & {
  currentCondition: Condition;
}) {
  const theme = useTheme();

  const isSelected = condition === currentCondition;

  return (
    <Button
      sx={{
        width: '60px',
        bgcolor: isSelected ? theme.palette.accent.main : '',
        fontWeight: isSelected ? 'bold' : undefined,
        ':hover': {
          bgcolor: isSelected ? theme.palette.accent.main : undefined,
        },
      }}
      onClick={() => onChange(condition)}>
      {condition === 'ALL' ? 'And' : 'Or'}
    </Button>
  );
}

export default function ConditionButton({
  condition,
  onChange,
}: ConfitionButtonGroupProps) {
  return (
    <ButtonGroup disableElevation variant="light">
      <SingleConditionButton
        condition="ALL"
        currentCondition={condition}
        onChange={onChange}
      />
      <SingleConditionButton
        condition="ANY"
        currentCondition={condition}
        onChange={onChange}
      />
    </ButtonGroup>
  );
}
